import { FC } from 'react'

export interface AccountProps {
  width?: number
  height?: number
}

const Account: FC<AccountProps> = ({ width, height }) => {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      height={height || 24}
      width={width || 24}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g id="Layer_1">
          <circle cx="11.9" cy="7.1" r="6" />
          <path d="M1.5,23.4c0-5.7,4.6-10.3,10.3-10.3s10.3,4.6,10.3,10.3" />
        </g>
      </g>
    </svg>
  )
}

export default Account
